import Vue from 'vue';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';
import { SuburbsInZipCodeStateManager as StateManager } from '../../domain/state-manager/suburbs-in-zip-code';
import State from '../../domain/state-manager/suburbs-in-zip-code/state';

@Injectable()
export default class SuburbsInZipCodeVueStateManager implements StateManager {
  private _state: State = Vue.observable<State>(new State());

  private readonly observers: Observer[] = [];

  get state(): State {
    return this._state;
  }

  set state(value: State) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: State) {
    this.state.suburbs = state.suburbs;
    this.state.zip_code = state.zip_code;
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
